import { Typography, Grid, List, ListItem, Link } from '@mui/material';
import { colors } from 'src/components/App/colors';

const GPAFormContent = () => {
  return (
    <Grid container>
      <Typography sx={{ color: colors['charcoal.700'], mb: 2 }} variant={'body2'}>
        Use this form to record CPD undertaken in practice or with your peers. When you add the
        details of additional RACGP participants, this activity will be added to their record too.
      </Typography>
      <Typography sx={{ color: colors['charcoal.700'] }} variant={'body2'}>
        CPD type to record based on activity content:
      </Typography>
      <List
        sx={{
          color: colors['charcoal.700'],
          listStyleType: 'disc',
          width: '100%',
          listStylePosition: 'outside',
          pl: 3
        }}
      >
        <ListItem sx={{ display: 'list-item', p: 0 }}>
          <Typography sx={{ color: colors['charcoal.700'] }} variant={'body2'}>
            educational activities (EA) – presentations/sharing information
          </Typography>
        </ListItem>
        <ListItem sx={{ display: 'list-item', p: 0 }}>
          <Typography sx={{ color: colors['charcoal.700'] }} variant={'body2'}>
            reviewing performance (RP) – sharing/reflecting on feedback, case-based discussion,
            reviewing processes
          </Typography>
        </ListItem>
        <ListItem sx={{ display: 'list-item', p: 0 }}>
          <Typography sx={{ color: colors['charcoal.700'] }} variant={'body2'}>
            measuring outcomes (MO) – discussing and documenting quality improvements/implementing
            change.
          </Typography>
        </ListItem>
      </List>
      <Typography sx={{ color: colors['charcoal.700'], mb: 1 }} variant={'body2'}>
        You can record any combination of hours in the relevant CPD types.
      </Typography>

      <Typography sx={{ color: colors['charcoal.700'] }} variant={'body2'}>
        Typical group CPD activities include practice meetings, case-based discussions, peer group
        learning activities, audits and more. Additional information can be found in the relevant{' '}
        <Link rel="noreferrer" href="/guides-templates">
          guides and templates. 
        </Link>
      </Typography>
    </Grid>
  );
};
export { GPAFormContent };
